// extracted by mini-css-extract-plugin
export var aircallIframe = "_mf-3";
export var fabContainer = "_mf-5";
export var fabRinging = "_mf-6";
export var loadingOverlay = "_mf-4";
export var pulse = "_mf-7";
export var widgetContent = "_mf-2";
export var widgetPanel = "_mf-0";
export var widgetPanelExpanded = "_mf-1";